import {
  Image,
} from './branchInterface';
import { RequestStatus } from 'mobx-store';

export interface IDeglawyPortalContentStore {
  deglawyPortalContentsList: DeglawyPortalContent[];
  selectedDeglawyPortalContent: DeglawyPortalContent;
  loading: boolean;
  getDeglawyPortalContentRequestStatus: RequestStatus;

  getDeglawyContents(languageCode?: string): Promise<void>;

  updateDeglawyContentById(updatedDeglawyPortalContent: any, id: number, languageCode?: string): Promise<any>;

  getDeglawyContentById(id: number, languageCode: string): Promise<void>;
}


export class DeglawyPortalContent {
  deglawyPortalContentId: number;

  title: string;

  headerImage: (Image | File)[];

  body: string;

  constructor() {
    this.deglawyPortalContentId = 0;
    this.title = '';
    this.headerImage = [];
    this.body = '';
  }

  setId(id: number): void {
    this.deglawyPortalContentId = id;
  }

  getId(): number {
    return this.deglawyPortalContentId;
  }

  setTitle(newTitle: string): void {
    this.title = newTitle;
  }

  getTitle(): string {
    return this.title;
  }

  setBody(newBody: string): void {
    this.body = newBody;
  }

  getBody(): string {
    return this.body;
  }

  getHeaderImage(): (Image | File)[] {
    return this.headerImage;
  }

  setHeaderImage(headerImage: (Image | File)[]): void {
    this.headerImage = headerImage;
  }

  getContentToUpdate(): { deglawyPortalContentId: number; title: string; headerImageUrl: string | null; body: string } {
    return {
      deglawyPortalContentId: this.deglawyPortalContentId,
      title: this.title,
      headerImageUrl: (this.headerImage && this.headerImage.length ? this.getImageURL(this.headerImage[0]) : null),
      body: this.body,
    };
  }

  private getImageURL(image: (Image | File)): string | null {
    if (image && this.isImage(image)) {
      return image.imageUrl;
    }
    return null;
  }

  private isImage(image: any): image is Image {
    return 'imageUrl' in image;
  }
}
